import React from 'react';

import {View, StyleSheet, FlatList} from 'react-native';

import TrustPin from './TrustPin';
import TrustNotification from './TrustNotification';
import useIsWideDevice from '../../hooks/useIsWideDevice';

const TrustGrid = ({screenProps, trustBlocks}) => {
  const isTablet = useIsWideDevice();
  const numberOfColumns = isTablet ? 2 : 1;
  return (
    <FlatList
      // key forces re-render on screen size change
      key={numberOfColumns}
      numColumns={numberOfColumns}
      data={trustBlocks}
      keyExtractor={item => item.id}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={styles.flatListContainer}
      // columnWrapperStyle isn't supported when columns are 1
      columnWrapperStyle={isTablet ? styles.columnWrapper : undefined}
      renderItem={({item}) => {
        const notification = (
          <TrustNotification
            type={item.screenType}
            data={item.data}
            screenProps={screenProps}
          />
        );

        const subTitle =
          item.data.length === 1 ? '1 Item' : `${item.data.length} Items`;

        return (
          <View
            style={[
              styles.itemContainer,
              !isTablet && {maxWidth: '100%', flex: 1},
            ]}>
            <TrustPin
              title={item.title}
              subtitle={subTitle}
              type={item.screenType}
              fixedWidth={false}
              onPress={item.onPress}
              data={item.data}
              notification={notification}
            />
          </View>
        );
      }}
    />
  );
};

const styles = StyleSheet.create({
  flatListContainer: {
    flexGrow: 1,
  },
  itemContainer: {
    flex: 1 / 2,
    maxWidth: '48%',
    marginBottom: 12,
  },
  columnWrapper: {
    justifyContent: 'space-between', // Evenly space items in each row
  },
});

export default TrustGrid;
